import { Routes } from '@angular/router';
import { authGuard } from '@core/guards';

import { PartnerPortalStateService } from './membership-portal/services/partner-portal-state.service';

/*
 * Partner Platform routes: the Partner Portal at `/partner` (behind the auth guard) and the partner
 * sign-in / sign-up pages. Anything else falls back to the sign-in landing.
 *
 * Both are standalone route arrays (review MR !1 D3); there is no NgModule left in this app.
 */
export const APP_ROUTES: Routes = [
    {
        path: 'partner',
        canActivate: [authGuard],
        /*
         * ⚠ PROVIDED ON THIS ROUTE, NOT IN ROOT AND NOT ON A CHILD. A route's `providers` create one environment injector
         * for the route and every route under it - the same scope the lazy `MembershipPortalModule` gave it - so every
         * portal screen, guard and the shell share ONE instance. The router keeps that injector for the life of the tab,
         * exactly as it kept the module's, which is why the service ties its cache to the signed-in person and hospital.
         * Pinned by `app-routing.module.spec.ts`.
         */
        providers: [PartnerPortalStateService],
        loadChildren: () => import('./membership-portal/membership-portal.routing').then(m => m.MEMBERSHIP_PORTAL_ROUTES),
        // Where sign-in ends up: downloaded early, after the entity chooser (see IdlePreloadStrategy).
        data: { preloadPriority: 1 }
    },
    {
        path: '',
        loadChildren: () => import('./prepage/prepage.routing').then(m => m.PREPAGE_ROUTES)
    },
    {
        path: '**',
        redirectTo: '/partner-signin'
    }
];
